import { Box } from '@byecode/ui'
import type { ApplicationSettingAuthentication } from '@lighthouse/core'
import * as React from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'

import PerfectFieldCollapse from '../PerfectFieldCollapse'

interface PerfectGroupSettingProps {}

const PerfectGroupSetting: React.FunctionComponent<PerfectGroupSettingProps> = props => {
    const { control } = useFormContext<ApplicationSettingAuthentication>()

    const { fields: roleSetting } = useFieldArray({
        control,
        name: 'perfect.roleSetting'
    })

    return (
        <Box px={8}>
            {roleSetting.map(({ roleId }, index) => {
                return <PerfectFieldCollapse prefix={`perfect.roleSetting.${index}`} key={roleId} roleId={roleId ?? ''} />
            })}
        </Box>
    )
}

export default PerfectGroupSetting
